<template>
  <div class="client-container">
    <div :style="{ overflow: 'hidden' }">
      <bread-crumb :style="{ float: 'left' }" />
      <a-button
        type="primary"
        shape="round"
        icon="plus"
        :style="{ float: 'right', marginTop: '19px' }"
        @click="editAndAdd"
      >
        新增标签
      </a-button>
    </div>
    <div class="global-table-container">
      <a-table
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="record => record.id"
        :pagination="{
          pageSize,
          total,
          current,
          showTotal: total => `共${total}条`,
        }"
        @change="changePage"
      >
        <template
          slot="operation"
          slot-scope="text, record"
        >
          <a
            href="javascript:;"
            @click="() => editAndAdd(record)"
          >编辑</a>
          <a-divider type="vertical" />
          <popconfirm-button
            :text="record.status===1?'禁用':'启用'"
            :alert-title="record.status===1?'确定禁用？':'确定启用？'"
            @onDelete="() => onConfirm(record)"
          />
        </template>
      </a-table>
    </div>
    <add-edit-modal
      ref="formRef"
      :title="title"
      :visible="visible"
      :type-id="typeId"
      :btn-is-loading="btnIsLoading"
      @onCancel="onCancel"
      @handleSubmit="onSubmit"
    />
  </div>
</template>
<script>
import {
  columns,
} from './data/index';
import addEditModal from './modal/index';
export default {
  components: { addEditModal},
  data() {
    return {
      columns,
      data: [],
      pageSize: 10,
      current: 1,
      total: 0,
      loading: false,
      btnIsLoading: false,
      title: '',
      visible: false,
      typeId: '',
      id: '',
    };
  },
  mounted() {
    // 获取表格数据
    this.getTableData({page: this.current, pageSize: this.pageSize});
  },
  methods: {
    // 获取表格数据
    async getTableData(params) {
      this.loading=true;
      let result = await this.$http.post('/portalTag/getList', params);
      if (result.data.status===1) {
        this.loading = false;
        this.total = result.data.data.count;
        let data = result.data.data.data_list;
        let temp = [];
        data.forEach((item) => {
          let obj = {
            id: item.id,
            status: item.status,
            name: item.name,
            data: item,
          };
          temp.push(obj);
        });
        this.data = temp;

      }
    },
    // 编辑或新增
    async editAndAdd(record) {
      console.log('editAndAdd -> record', record);
      this.visible=true;
      if(!record){
        this.title='新增标签';
        this.id='';
      }else{
        this.title='编辑标签';
        this.id=record.id;
        let data={
          name: record.name,
        };
        this.$nextTick(()=>{
          this.$refs.formRef.$refs.basicForm.form.setFieldsValue(data);
        });
      }
    },
    // 确定编辑或新增
    onSubmit() {
      this.$refs.formRef.$refs.basicForm.form.validateFields(
        async(err, values) => {
          if (!err) {
            this.btnIsLoading=true;
            let result=await this.$http.post('/portalTag/update', { id: this.id, ...values});
            this.btnIsLoading=false;
            if(result.data.status===1){
              this.$message.success('操作成功！');
              this.getTableData({page: this.current, pageSize: this.pageSize});
              this.visible = false;
            }
          }
        },
      );
    },
    // 取消编辑或新增
    onCancel() {
      this.visible = false;
    },
    // 禁用 启用
    async onConfirm(record) {
      let result=await this.$http.post('/portalTag/setStatus', {id: record.id, status: record.status===1?0:1});
      if(result.data.status===1){
        this.$message.success('操作成功！');
        this.getTableData({page: this.current, pageSize: this.pageSize});
      }
    },
    // 分页
    changePage(pagination) {
      this.current=pagination.current;
      this.getTableData({page: this.current, pageSize: this.pageSize});
    },
  },
};
</script>
<style lang="scss" scoped>

</style>
